// extracted by mini-css-extract-plugin
export default {"approval-status":"SelfReadList_approval-status__S-n4F"};